import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import axios from "axios";
import { Button, TextField, Modal, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { setLocation } from "../redux/slices/locationSlice";
import { toast } from "react-toastify";
import "../components/editmodal.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/EditNote";
import Divider from "@mui/material/Divider";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "70vh",
    overflowY: "auto",
    width:"95%",
    maxWidth: 400,

    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    paddingTop: 10,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    outline: "none",
    borderRadius: 5,
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,
    overflow: "hidden",
  },
  label: {
    fontWeight: "bold",
  },
  fieldContainer: {
    display: "flex",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
  },

  buttonSubDiv: {
    display: "flex",
    gap: ".5rem",
  },

  divider: {
    margin: "20px 0",
  },
}));

const EditLocationForm = ({
  selectedOption,
  selectedItemId,
  locationData,
  handleClose,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const oldLocationData = useSelector((state) => state.location);
  const [formData, setFormData] = useState({
    building: "",
    floor: "",
    city: "",
    customProperties: {},
  });
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const toggleAdvanced = () => {
    setShowAdvanced((prev) => {
      const newShowAdvanced = !prev;
      if (!newShowAdvanced) {
        setEditMode(false);
      }
      return newShowAdvanced;
    });
  };

  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };
  const handleCustomPropertyChange = (event) => {
    const { name, value } = event.target;
 
    setFormData((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        [name]: value,
      },
    }));
  };
  const handleAddCustomProperty = () => {
    if (newKey && newValue) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          [newKey]: newValue,
        },
      }));
      setNewKey("");
      setNewValue("");
    }
  };
  useEffect(() => {
    const selectedLocation = locationData.find(
      (location) => location.id === selectedItemId
    );

    if (selectedLocation) {
      setFormData({
        building: selectedLocation?.building,
        floor: selectedLocation?.floor,
        city: selectedLocation?.city,
        customProperties: {
          ...selectedLocation?.customProperties,
        },
      });
    }
  }, [selectedItemId, locationData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "locationUrl") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          locationUrl: value,
        },
      }));
    }
    if (name === "GuestWiFiDetails") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          GuestWiFiDetails: value,
        },
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();

    const requestBody = {
      path: "location",
      query: {},
      emmsId: selectedOption,
      body: {
        ...formData,
        id: selectedItemId,
      },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const api = localStorage.getItem("api");

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        const editedLocation = response.data[0];
        const index = oldLocationData.location.findIndex(
          (location) => location.id === editedLocation.id
        );

        if (index !== -1) {
          const updatedLocationData = [...oldLocationData.location];
          updatedLocationData[index] = editedLocation;
          dispatch(setLocation(updatedLocationData));
        } else {
          const updatedLocationData = [
            ...oldLocationData.location,
            editedLocation,
          ];
          dispatch(setLocation(updatedLocationData));
        }
        toast.success("Updated successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });

        handleClose();
      })
      .catch((error) => {
        console.error("Error updating location:", error);
        toast.error("Cannot be updated!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <>
      <Modal open={true} onClose={handleClose}>
        <Box sx={{minWidth:0}} className="centered-box">
          <form onSubmit={handleSubmit} className={classes.formContainer}>
            <h3> Edit Location </h3>

            {!showAdvanced && (
              <>
                {" "}
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Floor:", true)}
                  <TextField
                    required
                    id="floor"
                    name="floor"
                    size="small"
                    variant="outlined"
                    value={formData.floor}
                    onChange={handleChange}
                  />
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("City:", true)}
                  <TextField
                    required
                    id="city"
                    name="city"
                    size="small"
                    variant="outlined"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Building:", true)}
                  <TextField
                    required
                    id="building"
                    name="building"
                    size="small"
                    variant="outlined"
                    value={formData.building}
                    onChange={handleChange}
                  />
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Location URL:", true)}
                  <TextField
                    required
                    id="locationUrl"
                    label="eg. Google Location"
                    name="locationUrl"
                    margin="none"
                    size="small"
                    variant="outlined"
                    value={formData?.customProperties?.locationUrl}
                    onChange={handleChange}
                  />
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("WiFi Details:", false)}
                  <TextField
                    id="GuestWiFiDetails"
                    label="Guest WiFi Access Details"
                    name="GuestWiFiDetails"
                    margin="none"
                    size="small"
                    variant="outlined"
                    value={formData?.customProperties?.GuestWiFiDetails}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
            <div className={classes.buttonContainer}>
              <Button
                style={{
                  textTransform: "none",
                  marginRight:"4px"
                }}
                variant="outlined"
                color="primary"
                onClick={toggleAdvanced}
                startIcon={showAdvanced ? <ArrowBackIcon /> : null}
              >
                {showAdvanced ? "Back" : "Advanced"}
              </Button>
              {showAdvanced && (
                <Button
                  style={{
                    textTransform: "none",
                    whiteSpace:"nowrap"
                  }}
                  variant="contained"
                  color="primary"
                  onClick={toggleEditMode}
                  endIcon={!editMode ? <EditIcon /> : null}
                >
                  {editMode ? "Save Changes" : "Edit JSON"}
                </Button>
              )}

              {!showAdvanced && (
                <div className={classes.buttonSubDiv}>
                  <Button
                    style={{ textTransform: "none" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="small"
                  >
                    Update
                  </Button>
                  <Button
                    style={{ textTransform: "none" }}
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                    size="small"
                  >
                    Cancel
                  </Button>
                </div>
              )}
            </div>

            {showAdvanced && editMode && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Edit Custom Properties</h6>
                <div style={{ marginBottom: "10px" }}>
                  {Object.keys(formData.customProperties).map((key) => (
                    <div key={key} style={{ margin: "15px 0" }}>
                      <TextField
                        id={key}
                        name={key}
                        label={key}
                        variant="outlined"
                        size="small"
                        value={formData.customProperties[key]}
                        onChange={handleCustomPropertyChange}
                      />
                    </div>
                  ))}
                </div>
                {Object.keys(formData.customProperties).length > 0 && (
                  <div className={classes.divider}>
                    <Divider />
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <TextField
                    id="newKey"
                    name="newKey"
                    label="New Key"
                    variant="outlined"
                    size="small"
                    value={newKey}
                    onChange={(e) => setNewKey(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <TextField
                    id="newValue"
                    name="newValue"
                    label="New Value"
                    variant="outlined"
                    size="small"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={handleAddCustomProperty}
                  >
                    Add
                  </Button>
                </div>
              </div>
            )}
            {showAdvanced && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Custom Properties</h6>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                  }}
                >
                  {JSON.stringify(formData.customProperties, null, 2)}
                </pre>
              </div>
            )}
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default EditLocationForm;
